import { produce } from 'immer'
import { BaseControl, BaseFilter, BaseOption, BasicFilterStore } from './common'
import { analysisMode } from '../../../_constants/Code'

export class StatutoryClosureStore extends BasicFilterStore {}

export default class StatutoryClosureFilter extends BaseFilter {
  #groups = []
  #controls = new Map()
  #options = new Map()
  #result

  static DISPLAY_TYPE_KEY = 'displayType'
  static SECONDMENT_HANDLING = 'secondmentHandling'

  store = new StatutoryClosureStore()

  constructor(result) {
    super(result)
    this.#result = result
  }

  async init() {
    this.createOptions()
    this.createControls()
    this.createGroups()
  }

  /**
   * コントロールIDからオプションIDリスト
   *
   * @param {string} コントロールID
   */
  getOptionListFromControlId(id) {
    const optionIdList = []

    this.#options.forEach((e) => {
      if (e.meta.controlId === id) {
        optionIdList.push(e.id)
      }
    })
    return optionIdList
  }

  /** @param {Map<string, Option>} options */
  addToOptions(options = new Map()) {
    if (!this.#options) {
      this.#options = new Map()
    }

    this.#options = produce(this.#options, (draft) => {
      options.forEach((v, k) => {
        draft.set(k, v)
      })
    })
  }

  dfToObj(df, col, fields = []) {
    return df[col]
      .map((cell, i) => {
        if (cell === null) return null

        const entry = Object.fromEntries(fields.map((field) => [field, df[field][i]]))

        return { ...entry, sort: cell }
      })
      .filter(Boolean)
  }

  createSectionOptions() {
    const { dashboardId, mode } = this.#result

    const _dashboardId = mode === 'consolidated' ? dashboardId + '-g-d' : dashboardId

    const df = {
      label: ['全社', '正社員区分', '職種', '雇用区分', '分類なし', '管理職区分'],
      value: ['全社', '正社員区分', '職種', '雇用区分', '分類なし', '管理職区分'],
      '10.2.1': [null, 1, 3, 4, null, 2],
      '10.4.1': [1, null, null, 2, null, null],
      '10.1.5': [1, 2, 3, 4, null, null],
      '10.2.1-g-d': [null, null, null, 3, 1, 2],
      '10.1.5-g-d': [null, null, null, 2, 1, null]
    }

    const _options = this.dfToObj(df, _dashboardId, ['label', 'value'])
    _options.sort((a, b) => a.sort - b.sort)

    const options = _options.map((e) => {
      const option = new BaseOption(e.label, e.value, e.value).set('meta', {
        controlId: SectionControl.C_KEY
      })

      option.setState('value', false)

      return [e.value, option]
    })
    const firstOption = options[0][1]
    firstOption.setState('value', true)

    this.addToOptions(new Map(options))
  }

  createSecondmentTypeOptions() {
    const labels = this.#result.secondmentTypeOptions
    const defaultValue = this.#result.secondmentTypeValue

    const options = [
      {
        name: '未選択',
        value: '',
        key: 'emptySecondmentType'
      },
      ...labels
    ].map((e) => {
      const { name, value, key } = e
      const option = new BaseOption(key, name, value).set('meta', {
        controlId: SecondmentType.C_KEY
      })

      option.setState('value', value === defaultValue)

      return [key, option]
    })

    this.addToOptions(new Map(options))
  }

  createAggregationUnitOptions() {
    const options = ['セグメント', '会社'].map((e) => {
      const optionKey = AggregationUnit.C_KEY + e
      const option = new BaseOption(optionKey, e, e).set('meta', {
        controlId: AggregationUnit.C_KEY
      })
      option.setState('value', e === '会社')

      return [optionKey, option]
    })

    this.addToOptions(new Map(options))
  }

  createOptions() {
    this.createSectionOptions()
    this.createSecondmentTypeOptions()
    this.createAggregationUnitOptions()
  }

  createControls() {
    const aggregationUnit = new AggregationUnit()
    aggregationUnit.setOptionIdList(this.getOptionListFromControlId(aggregationUnit.id))

    const sectionControl = new SectionControl()
    sectionControl.setOptionIdList(this.getOptionListFromControlId(sectionControl.id))

    const secondmentTypeControl = new SecondmentType()
    secondmentTypeControl.setOptionIdList(this.getOptionListFromControlId(secondmentTypeControl.id))

    this.#controls.set(AggregationUnit.C_KEY, aggregationUnit)
    this.#controls.set(SectionControl.C_KEY, sectionControl)
    this.#controls.set(SecondmentType.C_KEY, secondmentTypeControl)
  }

  getControlIds() {
    const { mode, dashboardId } = this.#result
    const controls = [SectionControl.C_KEY, SecondmentType.C_KEY]

    if (mode === analysisMode.consolidated && ['10.2.1', '10.1.5'].includes(dashboardId))
      controls.unshift(AggregationUnit.C_KEY)

    return controls
  }

  /** @param {any} フィルターのグループを作成 */
  createGroups() {
    this.#groups.push({
      title: '',
      controlIdList: this.getControlIds(),
      disabled: false,
      show: true
    })
  }

  getConfig() {
    return {
      options: this.#options,
      controls: this.#controls,
      groups: this.#groups,
      generateOutput: this.generateOutput
    }
  }
}

class AggregationUnit extends BaseControl {
  //集計単位
  static C_KEY = 'groupby'

  constructor(...args) {
    super(...args)
    this.id = AggregationUnit.C_KEY
    this.label = '集計単位'
    this.type = 'select'
  }
}

class SectionControl extends BaseControl {
  static C_KEY = 'section'

  constructor(...args) {
    super(...args)

    this.id = SectionControl.C_KEY
    this.label = '表示分類'
    this.type = 'select'
  }
}

class SecondmentType extends BaseControl {
  static C_KEY = 'secondmentType'

  constructor(...args) {
    super(...args)

    this.id = SecondmentType.C_KEY
    this.label = '出向者の取り扱い'
    this.type = 'select'
  }
}
